import { useMemo } from "react";

/**
 * returns true if ANY member in the channel has disabled chat.
 */

export function useChatDisabled(activeChannel) {
  return useMemo(() => {
    if (!activeChannel) return false;

    const members = Object.values(activeChannel.state.members || {});

    return members.some(member => member.user && (member.user.share === false || member.user.is_active === false));
  }, [activeChannel]);
}

/**
 * returns true only if the SECONDARY (other) user has disabled chat.
 */
export function useSecondaryChatDisabled(activeChannel, currentUserId) {
  return useMemo(() => {
    if (!activeChannel || !currentUserId) return false;

    const members = Object.values(activeChannel.state?.members || {});
    const other = members.find(
      (m) => m?.user?.id && m.user.id !== currentUserId
    )?.user;

    if (!other) return false;

    return other.share === false || other.is_active === false;
  }, [activeChannel, currentUserId]);
}
